const normalize = (value) => (value || '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase();

export const PC_COMPONENTS = [
  { key: 'processor', name: 'Processador', translationKey: 'Processor', icon: 'processor', prefixes: ['Processador'], multiple: false },
  { key: 'cooler', name: 'Cooler', translationKey: 'Cooler', icon: 'cooler', prefixes: ['Cooler'], multiple: false },
  { key: 'motherboard', name: 'Placa-mãe', translationKey: 'Motherboard', icon: 'motherboard', prefixes: ['Placa Mae'], multiple: false },
  { key: 'memory', name: 'Memória RAM', translationKey: 'RAM memory', icon: 'memory', prefixes: ['Memória RAM'], multiple: true },
  { key: 'storage', name: 'Armazenamento', translationKey: 'Storage', icon: 'storage', prefixes: ['SSD', 'HD'], multiple: true },
  { key: 'case', name: 'Gabinete', translationKey: 'PC case', icon: 'case', prefixes: ['Gabinete'], multiple: false },
  { key: 'power', name: 'Fonte de alimentação', translationKey: 'Power supply', icon: 'power', prefixes: ['Fonte'], multiple: false },
  { key: 'video', name: 'Placa de vídeo', translationKey: 'Video card', icon: 'video', prefixes: ['Placa De Vídeo'], multiple: false },
  { key: 'extras', name: 'Periféricos, acessórios e extras', translationKey: 'Peripherals, accessories and extras', icon: 'extras', prefixes: [], multiple: true },
];

export const matchesPcComponent = (product, component) => {
  if (!component.prefixes.length) return false;
  const name = normalize(product.name);
  return component.prefixes.some((prefix) => name.startsWith(normalize(prefix)));
};

export const getItemsByComponent = (products, component) => (
  products.filter((product) => matchesPcComponent(product, component))
);

export const getExtraItems = (products) => (
  products.filter((product) => !PC_COMPONENTS.slice(0, -1).some(
    (component) => matchesPcComponent(product, component),
  ))
);
